import PagesTemplate from "../../templates/PagesTemplate/PagesTemplate";

const PagesPage = () => {
  return <PagesTemplate />;
};

export default PagesPage;
